<template>
    <hts-popover
        ref="popover"
        class="hts-tooltip"
        :trigger="trigger"
        :reference-class="referenceClass"
        :offset="offset"
        :arrow="false"
        :max-width="maxWidth"
        :placement="placement">
        <template #reference>
            <slot name="reference" />
        </template>
        <div class="p-1">
            <slot>
                <span v-if="content">
                    {{ content }}
                </span>
            </slot>
        </div>
    </hts-popover>
</template>
<script lang="ts" setup>
const props = defineProps({
  referenceClass: String,
  content: String,
  maxWidth: {
    type: [String, Number],
    default: 350
  },
  offset: {
    type: Array,
    default: () => [0, 5]
  },
  placement: {
    type: String,
    default: 'bottom'
  },
  trigger: {
    type: String,
    default: 'mouseenter focus'
  }
})

const popover = ref()

const show = () => {
  if (popover.value) {
    return popover.value.show()
  }
}
const hide = () => {
  if (popover.value) {
    return popover.value.hide()
  }
}

defineExpose({
  show,
  hide
})
</script>
